import React from "react";
import { Link } from "react-router-dom";

import EyeIcon from "../../../asset/images/home/icon/fi-rr-eye.png";
import EarIcon from "../../../asset/images/home/icon/ear.png";
import MicIcon from "../../../asset/images/home/icon/fi-rr-microphone-alt.png";

function Table() {
    return (
        <main className="bg-white p-6 sm:p-8 w-full max-w-7xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                Lesson 2: Single Letter Sounds (All about the ABCs)
            </h3>

            <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                Single Letter Sounds
            </h3>

            <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                <p className="ml-2">
                    Examine the table below to understand how to teach these sounds to
                    your students. All the highlighted portions are sections you will
                    speak. Student response is given, accordingly. When you are ready,
                    select, Continue.
                </p>
            </div>

            {/* Row 1 */}
            <div className="grid grid-cols-5 grid-rows-1 gap-2 overflow-hidden mb-2">
                <div className="bg-[#E2F2FF] text-center flex flex-col justify-center items-center rounded-tl-2xl p-4">
                    <img src={EyeIcon} height="50" width="50" alt="See" />
                    <span className="text-2xl font-bold text-gray-800">SEE</span>
                </div>

                <div className="col-span-4 bg-[#E2F2FF] flex items-center rounded-tr-2xl p-4">
                    <p className="text-gray-700 text-sm leading-relaxed">
                        Click on the letter for the sound that you hear using only the core
                        sound for that letter. For example, C has two sounds. The core sound
                        is contained in the word "cat." You would not select the S sound for
                        C. You will have 10 seconds to respond. Let's begin.
                    </p>
                </div>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-5 grid-rows-1 gap-2 overflow-hidden mb-2">
                <div className="bg-[#E2F2FF] text-center flex flex-col justify-center items-center p-4">
                    <img src={EarIcon} height="50" width="50" alt="Hear" />
                    <span className="text-2xl font-bold text-gray-800">HEAR</span>
                </div>

                <div className="col-span-4 bg-[#E2F2FF] flex items-center p-4">
                    <p className="text-gray-700 text-sm leading-relaxed">
                        Click on the letter for the sound that you hear using only the core
                        sound for that letter. For example, C has two sounds. The core sound
                        is contained in the word "cat." You would not select the S sound for
                        C. You will have 10 seconds to respond. Let's begin.
                    </p>
                </div>
            </div>

            {/* Row 3 */}
            <div className="grid grid-cols-5 grid-rows-1 gap-2 overflow-hidden mb-2">
                <div className="bg-[#E2F2FF] text-center flex flex-col justify-center items-center rounded-bl-2xl p-4">
                    <img src={MicIcon} height="50" width="50" alt="Do" />
                    <span className="text-2xl font-bold text-gray-800">DO</span>
                </div>

                <div className="col-span-4 bg-[#E2F2FF] flex items-center rounded-br-2xl p-4">
                    <p className="text-gray-700 text-sm leading-relaxed">
                        Click on the letter for the sound that you hear using only the core
                        sound for that letter. For example, C has two sounds. The core sound
                        is contained in the word "cat." You would not select the S sound for
                        C. You will have 10 seconds to respond. Let's begin.
                    </p>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex justify-end mt-5">
                <Link to="/dashboard/modules/audio-card">
                    <button className="px-6 py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8">
                        ← Previous
                    </button>
                </Link>

                <Link to="/dashboard/modules/card-see">
                    <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                        Continue Lesson →
                    </button>
                </Link>
            </div>
        </main>
    );
}

export default Table;
